import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './i18n/LanguageContext';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ChatWidget } from './components/ChatWidget';
import { HomePage } from './pages/HomePage';
import { ProductsPage } from './pages/ProductsPage';
import { BeforeAfterPage } from './pages/BeforeAfterPage';
import { TreatmentAreasPage } from './pages/TreatmentAreasPage';
import { LaosMarketPage } from './pages/LaosMarketPage';
import { AboutPage } from './pages/AboutPage';
import { BlogPage } from './pages/BlogPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <LanguageProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <div className="min-h-screen bg-white font-sans selection:bg-brand-lightCopper selection:text-brand-darkCopper" data-id="element-2">
          <Navbar data-id="element-3" />

          <main data-id="element-4">
            <Routes data-id="element-5">
              <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
              <Route path="/products" element={<ProductsPage data-id="element-9" />} data-id="element-8" />
              <Route path="/before-after" element={<BeforeAfterPage data-id="element-11" />} data-id="element-10" />
              <Route path="/treatment-areas" element={<TreatmentAreasPage data-id="element-13" />} data-id="element-12" />
              <Route path="/laos-market" element={<LaosMarketPage data-id="element-15" />} data-id="element-14" />
              <Route path="/about" element={<AboutPage data-id="element-17" />} data-id="element-16" />
              <Route path="/blog" element={<BlogPage data-id="element-19" />} data-id="element-18" />
              <Route path="/contact" element={<ContactPage data-id="element-21" />} data-id="element-20" />
            </Routes>
          </main>

          <Footer data-id="element-22" />
          <ChatWidget data-id="element-23" />
        </div>
      </BrowserRouter>
    </LanguageProvider>;
}